import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconInteractive(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92 6.937a2.796 2.796 0 1 1 5.592 0v6.038h2.85a5.049 5.049 0 0 1 5.049 5.049v4.654a.822.822 0 0 1-1.643 0v-4.654a3.406 3.406 0 0 0-3.406-3.406h-3.671a.821.821 0 0 1-.822-.821v-6.86a1.153 1.153 0 1 0-2.307 0v8.992a.821.821 0 0 1-.67.807l-.658.124a1.997 1.997 0 0 0-1.275 3.094l1.553 2.259a.821.821 0 1 1-1.354.93l-1.553-2.257c-1.49-2.165-.264-5.145 2.314-5.638V6.937Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.001 23.5c-.552 0-1-.682-1-1.08s-.052-.72.5-.72H19.5c.552 0 .5.682.5 1.08s.052.72-.5.72H7ZM9.754 2.143a5.11 5.11 0 0 0-4.978 6.274.821.821 0 1 1-1.6.372 6.754 6.754 0 1 1 13.156 0 .821.821 0 1 1-1.6-.372 5.11 5.11 0 0 0-4.978-6.274Z"
  }));
}
IconInteractive.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconInteractive.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconInteractive as default };
